import PublicLayout from '../components/layout/PublicLayout';

export default function PrivacyPage() {
  return (
    <PublicLayout>
      <div
        className="content-page"
        style={{
          width: '100%',
          boxSizing: 'border-box',
          padding: '56px 24px 80px',
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        <article
          className="content-card"
          style={{
            width: 'min(820px, 100%)',
            background: 'var(--surface-card)',
            borderRadius: 'var(--radius-lg)',
            boxShadow: 'var(--shadow-card)',
            padding: '56px clamp(24px, 5vw, 60px)',
          }}
        >
          <h1 style={{ fontSize: 'clamp(32px, 4vw, 44px)', margin: '0 0 6px' }}>Privatlivspolitik</h1>
          <p style={{ margin: '0 0 8px', fontSize: 14, color: 'var(--text-muted)' }}>
            Senest opdateret: <time dateTime="2026-11-01">1. november 2026</time>
          </p>
          <div className="content-copy" style={{ color: 'var(--text-body)', fontSize: 16, lineHeight: 1.7, display: 'flex', flexDirection: 'column', gap: 8 }}>
            <h2 style={{ fontSize: 22, margin: '32px 0 4px' }}>Hvem er vi?</h2>
            <p style={{ margin: 0 }}>
              Vores hjemmeside www.gymgpt.dk drives som en læringstjeneste af AI-kuja:
            </p>
            <ul style={{ margin: 0, paddingLeft: 22, listStyle: 'none' }}>
              <li>CVR-nr.: 46690494</li>
              <li>Sallingelunde 8</li>
              <li>5750 Ringe</li>
            </ul>
            <p style={{ margin: 0 }}>
              Du kan kontakte den dataansvarlige AI-kuja via Bjørn la Cour Poulsen på mail bcp@selvstudier.dk.
            </p>
            <h2 style={{ fontSize: 22, margin: '32px 0 4px' }}>Hvilke personoplysninger behandler vi?</h2>
            <h3 style={{ fontSize: 18, margin: '16px 0 2px' }}>Chatbotten</h3>
            <p style={{ margin: 0 }}>
              Når du skriver til chatbotten, behandles dine data af Ordbogen A/S (Chat.dk), Google Cloud og Mistral AI, som
              genererer et svar og returnerer det til dig. GymGPT gemmer beskeder og svar midlertidigt, så samtalen kan vises
              igen. Der er indgået aftaler med Google Cloud, Ordbogen A/S og Mistral AI om, at de ikke anvender samtaler til
              at træne deres modeller.
            </p>
            <h3 style={{ fontSize: 18, margin: '16px 0 2px' }}>Drift og vedligeholdelse</h3>
            <p style={{ margin: 0 }}>
              For drift, fejlfinding og kvalitetssikring af chatbotten gemmes beskeder, svar og IP-adresser. Dette bruges
              ikke til markedsføring eller træning af sprogmodeller.
            </p>
            <h3 style={{ fontSize: 18, margin: '16px 0 2px' }}>Serverlogs</h3>
            <p style={{ margin: 0 }}>
              Når du besøger hjemmesiden eller bruger chatbotten, behandler vores webhotel og AI-server tekniske
              oplysninger som din IP-adresse, browsertype og tidspunkt for besøget eller anmodningen. Disse oplysninger
              anvendes til drift, sikkerhed og fejlfinding og opbevares i en begrænset periode i serverlogs.
            </p>
            <h3 style={{ fontSize: 18, margin: '16px 0 2px' }}>Brugerkonti</h3>
            <p style={{ margin: 0 }}>
              Du kan bruge GymGPTs chatbotter som elev uden at oprette konto. Samtaler knyttes til et anonymt
              sessions-id i din browser.
            </p>
            <p style={{ margin: 0 }}>
              Lærere kan oprette en konto via et invitationslink. Ved oprettelse og brug af lærerkonto behandler vi navn,
              e-mailadresse og en krypteret adgangskode. Gennem kontoen kan du også gemme og administrere materiale, du
              selv vælger at dele — f.eks. dokumenter til vidensdatabaser, chatbot-indstillinger og systemprompts til egne
              assistenter.
            </p>
            <h3 style={{ fontSize: 18, margin: '16px 0 2px' }}>Lærerkode</h3>
            <p style={{ margin: 0 }}>
              Adgang med en lærerkode via siden www.gymgpt.dk/klassevaerelset er anonym og midlertidig (typisk 2 timer). Det giver
              ikke en brugerkonto, og dine chatbot-samtaler følger stadig den automatiske sletning inden for 7 dage, som
              beskrevet nedenfor.
            </p>

            <div style={{ background: 'var(--blue-50)', borderLeft: '4px solid var(--blue-600)', borderRadius: 8, padding: '14px 18px', margin: '6px 0' }}>
              <p style={{ margin: 0 }}>
                For at undgå indsamling af personoplysninger, skriv ikke personhenførbare oplysninger som dit navn,
                adresse, CPR-nummer eller personfølsomme oplysninger til chatbotten.
              </p>
            </div>

            <h2 style={{ fontSize: 22, margin: '32px 0 4px' }}>Retsgrundlag</h2>
            <p style={{ margin: 0 }}>Vi behandler dine oplysninger på følgende grundlag:</p>
            <ul style={{ margin: 0, paddingLeft: 22 }}>
              <li>
                <strong>Levering af tjenesten:</strong> Behandlingen er nødvendig for at opfylde det, du har bedt om —
                jf. Databeskyttelsesforordningens (GDPR) artikel 6, stk. 1, litra b.
              </li>
              <li>
                <strong>Drift, sikkerhed og fejlfinding:</strong> Vores legitime interesse i at drive en stabil og sikker
                hjemmeside — jf. Databeskyttelsesforordningens (GDPR) artikel 6, stk. 1, litra f.
              </li>
            </ul>

            <h2 style={{ fontSize: 22, margin: '32px 0 4px' }}>Hvor behandles og opbevares dine data?</h2>
            <p style={{ margin: 0 }}>
              Al behandling og opbevaring sker hos leverandører inden for EU/EØS. Det gælder hosting af hjemmesiden,
              vores API og database, opbevaring af data til drift og fejlfinding, samt de sprogmodeller, der anvendes.
            </p>
            <p style={{ margin: 0 }}>
              Vi har indgået databehandleraftaler (DPA) med vores leverandører. Dine data overføres ikke til lande uden
              for EU/EØS.
            </p>

            <p style={{ margin: 0 }}>
              Ordbogen A/S, Google Cloud og Mistral AI bliver kun præsenteret for indholdet af dine samtaler. De har ikke
              adgang til IP-adresse, browser id eller andre tekniske oplysninger som vi indsamler for at drive vores service.
            </p>

            <h2 id="leverandoerer" style={{ fontSize: 22, margin: '32px 0 4px' }}>Leverandører</h2>
            <p style={{ margin: 0 }}>
              Vi bruger følgende leverandører til at drive GymGPT. Alle behandler data inden for EU/EØS:
            </p>
            <div className="privacy-table-wrap">
              <table className="privacy-table" aria-labelledby="leverandoerer">
                <thead>
                  <tr>
                    <th scope="col">Leverandør</th>
                    <th scope="col">Formål</th>
                    <th scope="col">Placering</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>AzeHosting</td>
                    <td>Hosting af hjemmeside (frontend)</td>
                    <td>Tyskland</td>
                  </tr>
                  <tr>
                    <td>Hetzner</td>
                    <td>Hosting af API og database (backend)</td>
                    <td>Tyskland</td>
                  </tr>
                  <tr>
                    <td>Google Cloud</td>
                    <td>AI-behandling</td>
                    <td>EU/EØS</td>
                  </tr>
                  <tr>
                    <td>Ordbogen A/S</td>
                    <td>AI-behandling</td>
                    <td>Danmark</td>
                  </tr>
                  <tr>
                    <td>Mistral AI</td>
                    <td>AI-behandling</td>
                    <td>EU/EØS</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <h2 style={{ fontSize: 22, margin: '32px 0 4px' }}>Hvor længe opbevares dine data?</h2>
            {/* <!-- Agent note: user-facing chat retention on this page is 7 dage by product decision. Do not change back to 6 to match CHATBOT_CONVERSATION_RETENTION_DAYS without operator sign-off. --> */}
            <ul style={{ margin: 0, paddingLeft: 22 }}>
              <li>
                <strong>Chatbot-samtaler:</strong> Slettes automatisk inden for 7 dage efter den seneste besked eller når
                du selv vælger at slette dem.
              </li>
              <li>
                <strong>Lærerforberedelse (lærerkonto):</strong> Samtaler i Lærerforberedelsen er knyttet til din
                lærerkonto og slettes ikke automatisk. De bliver liggende, indtil du selv sletter samtalen, eller vi
                sletter din konto efter din anmodning.
              </li>
              <li>
                <strong>Kvalitetssikring:</strong> Chatbeskeder bliver brugt til kvalitetssikring og fejlfinding og
                opbevares i op til 30 dage. Hvis man aktivt vælger at give feedback på et svar man har fået på en besked,
                kan beskeden blive opbevaret i længere tid med henblik på at sikre og forbedre kvaliteten af tjenesten.
                Dette vil altid være i anonymiseret form.
              </li>
              <li>
                <strong>Serverlogs:</strong> Opbevares i en kort periode til drifts- og sikkerhedsformål (typisk få uger
                og højst 6 måneder).
              </li>
            </ul>

            <h2 style={{ fontSize: 22, margin: '32px 0 4px' }}>Dine rettigheder</h2>
            <p style={{ margin: 0 }}>Du har efter databeskyttelsesforordningen følgende rettigheder:</p>
            <ul style={{ margin: 0, paddingLeft: 22 }}>
              <li>Ret til indsigt i, hvilke oplysninger vi behandler om dig.</li>
              <li>Ret til berigtigelse af urigtige oplysninger.</li>
              <li>Ret til sletning (“retten til at blive glemt”).</li>
              <li>Ret til begrænsning af behandlingen.</li>
              <li>Ret til dataportabilitet.</li>
              <li>Ret til at gøre indsigelse mod behandlingen.</li>
            </ul>
            <p style={{ margin: 0 }}>
              Du er altid velkommen til at kontakte os på bcp@selvstudier.dk, hvis du vil gøre brug af dine rettigheder —
              uanset om du bruger GymGPT med eller uden konto. Uden konto knyttes samtaler til et anonymt sessions-id i
              din browser.
            </p>

            <h2 style={{ fontSize: 22, margin: '32px 0 4px' }}>Klage</h2>
            <p style={{ margin: 0 }}>Hvis du er utilfreds med, hvordan vi behandler dine oplysninger, kan du klage til Datatilsynet:</p>
            <p style={{ margin: 0 }}>Datatilsynet, Carl Jacobsens Vej 35, 2500 Valby — www.datatilsynet.dk, dt@datatilsynet.dk</p>

            <h2 style={{ fontSize: 22, margin: '32px 0 4px' }}>Ændringer i privatlivspolitikken</h2>
            <p style={{ margin: 0 }}>Vi kan løbende opdatere denne privatlivspolitik, f.eks. hvis tjenesten ændres, eller lovgivningen kræver det. Den til enhver tid gældende version vil være tilgængelig på denne side med dato for seneste opdatering øverst.</p>
          </div>
        </article>
      </div>
    </PublicLayout>
  );
}
